module.exports = __webpack_public_path__ + "img/account-book-tax.773eb9df.png";